import Vue from 'vue'
import Router from 'vue-router'
import Personal from './personal'

Vue.use(Router)

let RouteList = [{
    path: '/home',
    component: resolve => require(['@/views/layout/App.vue'], resolve),
    meta: {
        title: '首页',
        keepAlive: false,
    },
    children: [{
        path: '/personal',
        name: 'personal',
        meta: {
            title: '个人中心',
            keepAlive: false
        },
        component: resolve => require(['@/views/personal/Index.vue'], resolve),
    },
    {
        path: '/home',
        name: 'Dashboard',
        meta: {
            title: '首页',
            keepAlive: false
        },
        component: resolve => require(['@/views/home/Index.vue'], resolve),
    },
    // 渠道列表
    {
        path: '/channel_data',
        name: 'channelData',
        meta: {
            title: '渠道列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/List.vue'], resolve),
    },
    // 渠道列表
    {
        path: '/channel_api',
        name: 'channelApi',
        meta: {
            title: '渠道API',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/channel_api.vue'], resolve),
    },
    // 充值记录
    {
        path: '/recharge_records',
        name: 'rechargeRecord',
        meta: {
            title: '充值记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/recharge_record.vue'], resolve),
    },
    // 扣款记录
    {
        path: '/deduction_record',
        name: 'deduction_record',
        meta: {
            title: '扣款记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/deduction_record.vue'], resolve),
    },

    // 承包规则审核
    {
        path: '/apl_rules',
        name: 'aplRules',
        meta: {
            title: '承包规则审核',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/apl_rules.vue'], resolve),
    },
    // 承包规则审核
    {
        path: '/pocketRules',
        name: 'pocketRules',
        meta: {
            title: '兜底规则审核',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/pocket_rules.vue'], resolve),
    },

    // 申请记录
    {
        path: '/apl_records',
        name: 'aplRecords',
        meta: {
            title: '申请记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/apl_records.vue'], resolve),
    },
    // 供应商承包申请
    {
        path: '/subscribes',
        name: 'subscribes',
        meta: {
            title: '供应商承包申请',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/subscribes.vue'], resolve),
    },
    // 供应商列表
    {
        path: '/supplier_list',
        name: 'supplierList',
        meta: {
            title: '供应商列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/supplier_list.vue'], resolve),
    },
    // 提现记录
    {
        path: '/withdrawal_records',
        name: 'withdrawalRecords',
        meta: {
            title: '提现记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/withdrawal_records.vue'], resolve),
    },
    // 供应商列表
    {
        path: '/acts',
        name: 'acts',
        meta: {
            title: '供应商列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/act.vue'], resolve),
    },
    // 自助签约
    {
        path: '/contract',
        name: 'contract',
        meta: {
            title: '自助签约',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/contract.vue'], resolve),
    },
    // 全部订单
    {
        path: '/all_orders',
        name: 'allOrders',
        meta: {
            title: '全部订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/all_orders.vue'], resolve),
    },
    {
        path: '/oil_orders',
        name: 'oilOrders',
        meta: {
            title: '油卡订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/oil_orders.vue'], resolve),
    },
    {
        path: '/mahua_orders',
        name: 'mahuaOrders',
        meta: {
            title: '点餐订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/mahua_orders.vue'], resolve),
    },
    {
        path: '/tel_orders',
        name: 'telOrders',
        meta: {
            title: '话费订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/tel_orders.vue'], resolve),
    },
    {
        path: '/telorders',
        name: 'tel_orders',
        meta: {
            title: '话费订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/tel_orders.vue'], resolve),
    },
    {
        path: '/settlement_list',
        name: 'settlement_list',
        meta: {
            title: '结算中订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/settlement_list.vue'], resolve),
    },
    {
        path: '/eshop_orders',
        name: 'eshop_orders',
        meta: {
            title: '话费订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/eshop_orders.vue'], resolve),
    },
    // 待抢订单
    {
        path: '/robing_orders',
        name: 'robingOrders',
        meta: {
            title: '待抢订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/robing_orders.vue'], resolve),
    },
    // 无人接单
    {
        path: '/norecev_orders',
        name: 'norecevOrders',
        meta: {
            title: '无人接单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/norecev_orders.vue'], resolve),
    },
    // 锁定订单
    {
        path: '/locking_orders',
        name: 'lockingOrders',
        meta: {
            title: '锁定订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/locking_orders.vue'], resolve),
    },
    // 出票成功订单
    {
        path: '/success_orders',
        name: 'successOrders',
        meta: {
            title: '出票成功订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/success_orders.vue'], resolve),
    },
    // 出票失败订单
    {
        path: '/error_order',
        name: 'errorOrder',
        meta: {
            title: '出票失败订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/error_order.vue'], resolve),
    },
    // 售后工单
    {
        path: '/order_afterSales',
        name: 'order_afterSales',
        meta: {
            title: '售后工单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/order_afterSales.vue'], resolve),
    },
    // 售后工单
    {
        path: '/afterSales_orders',
        name: 'afterSales_orders',
        meta: {
            title: '售后工单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/afterSales_orders.vue'], resolve),
    },
    // 售后工单详情
    {
        path: '/afterSales_detail',
        name: 'afterSales_detail',
        meta: {
            title: '售后工单详情',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/afterSales_detail.vue'], resolve),
    },
    // 出票识别记录
    {
        path: '/record',
        name: 'record',
        meta: {
            title: '出票识别记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/record.vue'], resolve),
    },
    // 收款订单
    {
        path: '/collection_order',
        name: 'collection_order',
        meta: {
            title: '收款订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/order/collection_order.vue'], resolve),
    },
    // 价格模板
    {
        path: '/price_template',
        name: 'priceTemplate',
        meta: {
            title: '影票价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/price_template.vue'], resolve),
    },
    {
        path: '/restaurant_price_template',
        name: 'restaurantPriceTemplate',
        meta: {
            title: '点餐价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/restaurant_price_template.vue'], resolve),
    },
    {
        path: '/bread_price_template',
        name: 'bread_price_template',
        meta: {
            title: '本地商家价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/bread_price_template.vue'], resolve),
    },
    {
        path: '/jd_price_edit',
        name: 'jd_price_edit',
        meta: {
            title: '保存京东价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/com/jd_price_edit.vue'], resolve),
    },
    {
        path: '/bread_price_edit',
        name: 'bread_price_edit',
        meta: {
            title: '保存面包价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/com/bread_price_edit.vue'], resolve),
    },
    {
        path: '/oil_price_template',
        name: 'oilPriceTemplate',
        meta: {
            title: '油卡价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/oil_price_template.vue'], resolve),
    },
    {
        path: '/tel_price_template',
        name: 'telPriceTemplate',
        meta: {
            title: '话费价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/tel_price_template.vue'], resolve),
    },

    {
        path: '/onlinePrice_template',
        name: 'onlinePrice_template',
        meta: {
            title: '商品价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/onlinePrice_template.vue'], resolve),
    },
        
    {
        path: '/robot_price_template',
        name: 'robot_price_template',
        meta: {
            title: '机器人新增模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/robot_price_template.vue'], resolve),
    },
    {
        path: '/robot_price_template_add',
        name: 'robotPriceTemplate',
        meta: {
            title: '机器人放单模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/robot_price_template_add.vue'], resolve),
    },
    {
        path: '/robot_price_template_js_add',
        name: 'robot_price_template_js_add',
        meta: {
            title: '机器人放单模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/robot_price_template_js_add.vue'], resolve),
    },
    {
        path: '/express_price_template',
        name: 'expressPriceTemplate',
        meta: {
            title: '机器人放单模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/express_price_template.vue'], resolve),
    },
    {
        path: '/express_price_template_add',
        name: 'express_price_template_add',
        meta: {
            title: '机器人放单模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/express_price_template_add.vue'], resolve),
    },
    // 价格设置 express_price_template
    // {
    //     path: '/price_set',
    //     name: 'priceSet',
    //     meta: {
    //         title: '价格设置',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/rules/price_set.vue'], resolve),
    // },
    {
        path: '/channel_develop',
        name: 'ChannelDevelop',
        meta: {
            title: '开发配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/Develop.vue'], resolve),
    },
    {
        path: '/charge_orders',
        name: 'ChargeOrders',
        meta: {
            title: '充值订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/charge/Orders.vue'], resolve),
    },
    {
        path: '/goods',
        name: 'Goods',
        meta: {
            title: '商品管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/goods/goods.vue'], resolve),
    },
    {
        path: '/goods_category',
        name: 'goods_category',
        meta: {
            title: '商品分类管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/goods/goods_category.vue'], resolve),
    },
    {
        path: '/brand',
        name: 'brand',
        meta: {
            title: '品牌维护',
            keepAlive: false
        },
        component: resolve => require(['@/views/goods/brand.vue'], resolve),
    },
    // 供应商设置
    {
        path: '/receive_set',
        name: 'receive_set',
        meta: {
            title: '供应商设置',
            keepAlive: false
        },
        component: resolve => require(['@/views/set/receive_set.vue'], resolve),
    },
    // 供应商设置
    {
        path: '/searchrule',
        name: 'searchrule',
        meta: {
            title: '规则查询',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/searchrule.vue'], resolve),
    },

    // 添加价格模板
    {
        path: '/template_add',
        name: 'template_add',
        meta: {
            title: '保存影票价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/template_add.vue'], resolve),
    },
    {
        path: '/restaurant_template_add',
        name: 'restaurant_template_add',
        meta: {
            title: '保存点餐价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/restaurant_template_add.vue'], resolve),
    },
    {
        path: '/goods_template_add',
        name: 'goods_template_add',
        meta: {
            title: '保存影视会员价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/goods_template_add.vue'], resolve),
    },
    {
        path: '/business_list',
        name: 'business_list',
        meta: {
            title: '商家管理',
            keepAlive: false,
            activeMenu:'/business_list'
        },
        component: resolve => require(['@/views/local/business_list.vue'], resolve),
    },
    {
        path: '/business_edit',
        name: 'business_edit',
        meta: {
            title: '商家信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/business_edit.vue'], resolve),
    },
    {
        path: '/inSettlement_list',
        name: 'inSettlement_list',
        meta: {
            title: '结算中',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/inSettlement_list.vue'], resolve),
    },
    {
        path: '/store_list',
        name: 'store_list',
        meta: {
            title: '门店管理',
            keepAlive: false,
            activeMenu:'/business_list'
        },
        component: resolve => require(['@/views/local/store_list.vue'], resolve),

    },
    {
        path: '/member_list',
        name: 'member_list',
        meta: {
            title: '成员管理',
            keepAlive: false,
            activeMenu:'/business_list'
        },
        component: resolve => require(['@/views/local/member_list.vue'], resolve),
    },
    {
        path: '/store_edit',
        name: 'store_edit',
        meta: {
            title: '门店信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/store_edit.vue'], resolve),
    },
    {
        path: '/goods_examine',
        name: 'goods_examine',
        meta: {
            title: '商品审核',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/goods_examine.vue'], resolve),
    },
    {
        path: '/examine_goods',
        name: 'examine_goods',
        meta: {
            title: '审核',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/examine_goods.vue'], resolve),
    },
    {
        path: '/goods_list',
        name: 'goods_list',
        meta: {
            title: '商品管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/goods_list.vue'], resolve),
    },
    {
        path: '/goods_edit',
        name: 'goods_edit',
        meta: {
            title: '商品信息',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/com/goods_edit.vue'], resolve),
    },
    // {
    //     path: '/order_list',
    //     name: 'order_list',
    //     meta: {
    //         title: '订单列表',
    //         keepAlive: false
    //     },
    //     component: resolve => require(['@/views/local/order_list.vue'], resolve),
    // },
    {
        path: '/local_order',
        name: 'local_order',
        meta: {
            title: '本地生活订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/local_order.vue'], resolve),
    },
    {
        path: '/blindBox_order',
        name: 'blindBox_order',
        meta: {
            title: '福袋订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/blindBox_order.vue'], resolve),
    },
    {
        path: '/goods_order',
        name: 'goods_order',
        meta: {
            title: '电商订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/goods_order.vue'], resolve),
    },
    {
        path: '/eCard_order',
        name: 'eCard_order',
        meta: {
            title: '卡劵订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/eCard_order.vue'], resolve),
    },
    {
        path: '/check_list',
        name: 'check_list',
        meta: {
            title: '核销管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/check_list.vue'], resolve),
    },
    {
        path: '/orderExamine',
        name: 'orderExamine',
        meta: {
          title: '申请退款审核',
          keepAlive: false
        },
        component: resolve => require(['@/views/local/orderExamine.vue'], resolve)
      },
    {
        path: '/write_list',
        name: 'write_list',
        meta: {
            title: '核销记录',
            keepAlive: false,
            activeMenu:'/check_list'
        },
        component: resolve => require(['@/views/local/write_list.vue'], resolve),
    },
    {
        path: '/comment_list',
        name: 'comment_list',
        meta: {
            title: '评论管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/comment_list.vue'], resolve),
    },
    {
        path: '/seckill',
        name: 'seckill',
        meta: {
            title: '秒杀活动',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/seckill.vue'], resolve),
    },
    {
        path: '/activity_review',
        name: 'activity_review',
        meta: {
            title: '活动审核',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/activity_review.vue'], resolve),
    },
    {
        path: '/logistics',
        name: 'logistics',
        meta: {
          title: '物流模版',
          keepAlive: false
        },
        component: resolve => require(['@/views/template/logistics.vue'], resolve)
      },
      {
        path: '/logistics_edit',
        name: 'logistics_edit',
        meta: {
          title: '保存物流模版',
          keepAlive: false
        },
        component: resolve => require(['@/views/template/com/logistics_edit.vue'], resolve)
      },
    // 积分价格模板
    {
        path: '/integral_template',
        name: 'integral_template',
        meta: {
            title: '积分价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/integral_template.vue'], resolve),
    },
    {
        path: '/integral_template_add',
        name: 'integral_template_add',
        meta: {
            title: '保存积分价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/integral_template_add.vue'], resolve),
    },
    {
        path: '/integral',
        name: 'integral',
        meta: {
            title: '积分规则',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/integral.vue'], resolve),
    },
    {
        path: '/integralAppeal',
        name: 'integralAppeal',
        meta: {
            title: '积分审核',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/integralAppeal.vue'], resolve),
    },
    {
        path: '/notice',
        name: 'notice',
        meta: {
            title: '通知公告',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/notice.vue'], resolve),
    }, {
        path: '/qrcode',
        name: 'qrcode',
        meta: {
            title: '客服二维码',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/qrcode.vue'], resolve),
    }, {
        path: '/recharge',
        name: 'recharge',
        meta: {
            title: '充值记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/supplier/recharge.vue'], resolve),
    }
        , {
        path: '/robot',
        name: 'robot',
        meta: {
            title: '机器人',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/robot.vue'], resolve),
    }, {
        path: '/robot_setting',
        name: 'robot_setting',
        meta: {
            title: '特惠配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/coms/robot_setting.vue'], resolve),
    },
    // 联联异常订单
    {
        path: '/llErrorOrder',
        name: 'llErrorOrder',
        meta: {
            title: '异常订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/llErrorOrder.vue'], resolve),
    },
    // 商务入住
    {
        path: '/shopSettle',
        name: 'shopSettle',
        meta: {
            title: '商务入住',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/shopSettle.vue'], resolve),
    },
    // 秒杀商品
    {
        path: '/seckillGoods',
        name: 'seckillGoods',
        meta: {
            title: '秒杀商品',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/seckillGoods.vue'], resolve),
    },
    // 本地生活提现记录
    {
        path: '/local_records',
        name: 'local_records',
        meta: {
            title: '提现记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/local_records.vue'], resolve),
    },
    // 代金券
    {
        path: '/voucher',
        name: 'voucher',
        meta: {
            title: '代金券',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/voucher.vue'], resolve),
    },
    // 代金券审核
    {
        path: '/voucher_examine',
        name: 'voucher_examine',
        meta: {
            title: '代金券审核',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/voucher_examine.vue'], resolve),
    },
    // 代金券门店
    {
        path: '/voucher_shops',
        name: 'voucher_shops',
        meta: {
            title: '代金券门店',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/voucher_shops.vue'], resolve),
    },
    // 代理商管理
    {
        path: '/agent_list',
        name: 'agent_list',
        meta: {
            title: '代理商管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/agent/agent_list.vue'], resolve),
    },
    // 公司管理
    {
        path: '/Information',
        name: 'Information',
        meta: {
            title: '公司管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/Information/Information.vue'], resolve),
    },
    // 充值订单
    {
        path: '/aiOrder',
        name: 'aiOrder',
        meta: {
            title: '充值订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/aiOrder.vue'], resolve),
    },
    // 碰一碰任务
    {
        path: '/task',
        name: 'task',
        meta: {
            title: '碰一碰任务',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/task.vue'], resolve),
    },
    // 碰一碰素材
    {
        path: '/source',
        name: 'source',
        meta: {
            title: '碰一碰素材',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/source.vue'], resolve),
    },
    // 碰一碰任务模板
    {
        path: '/template',
        name: 'template',
        meta: {
            title: '碰一碰任务模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/template.vue'], resolve),
    },
    // 碰一碰文案模板
    {
        path: '/textTemplate',
        name: 'textTemplate',
        meta: {
            title: '碰一碰文案模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/textTemplate.vue'], resolve),
    },
    // 碰一碰教程
    {
        path: '/tutorial',
        name: 'tutorial',
        meta: {
            title: '碰一碰教程',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/tutorial.vue'], resolve),
    },
    // 统计排行榜
    {
        path: '/theCharts',
        name: 'theCharts',
        meta: {
            title: '统计排行榜',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/theCharts.vue'], resolve),
    },
     // 碰一碰统计
     {
        path: '/statistics',
        name: 'statistics',
        meta: {
            title: '碰一碰统计',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/statistics.vue'], resolve),
    },
     // 背景音乐
     {
        path: '/bgm',
        name: 'bgm',
        meta: {
            title: '背景音乐',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/bgm.vue'], resolve),
    },
     // 售卖商品
     {
        path: '/sellGoods',
        name: 'sellGoods',
        meta: {
            title: '售卖商品',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/sellGoods.vue'], resolve),
    },
     // 售卖订单
     {
        path: '/sellOrder',
        name: 'sellOrder',
        meta: {
            title: '售卖订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/sellOrder.vue'], resolve),
    },
     // 二维码批次
     {
        path: '/batch',
        name: 'batch',
        meta: {
            title: '二维码批次',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/batch.vue'], resolve),
    },
     // 二维码
     {
        path: '/batchCode',
        name: 'batchCode',
        meta: {
            title: '二维码',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/batchCode.vue'], resolve),
    },
    // 任务列表
    {
        path: '/jhtask',
        name: 'jhtask',
        meta: {
            title: '任务列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/jhtask.vue'], resolve),
    },
    // 权益礼包
    {
        path: '/giftPackage',
        name: 'giftPackage',
        meta: {
            title: '权益礼包',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/giftPackage.vue'], resolve),
    },
    // 达人列表
    {
        path: '/promoter',
        name: 'promoter',
        meta: {
            title: '达人列表',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/promoter.vue'], resolve),
    },
    // 达人星级
    {
        path: '/level',
        name: 'level',
        meta: {
            title: '达人星级',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/level.vue'], resolve),
    },
    // 任务记录
    {
        path: '/taskRecord',
        name: 'taskRecord',
        meta: {
            title: '任务记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/taskRecord.vue'], resolve),
    },
    // 提现记录
    {
        path: '/taskWithdrawal',
        name: 'taskWithdrawal',
        meta: {
            title: '提现记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/taskWithdrawal.vue'], resolve),
    },
    // 基础配置
    {
        path: '/config',
        name: 'config',
        meta: {
            title: '基础配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/config.vue'], resolve),
    },
    // 一级达人模板
    {
        path: '/starTemplate',
        name: 'starTemplate',
        meta: {
            title: '一级达人模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/starTemplate.vue'], resolve),
    },
    // 二级达人模板
    {
        path: '/twoTemplate',
        name: 'twoTemplate',
        meta: {
            title: '二级达人模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/twoTemplate.vue'], resolve),
    },
    // 任务价格模板
    {
        path: '/priceTemplate',
        name: 'priceTemplate',
        meta: {
            title: '任务价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/priceTemplate.vue'], resolve),
    },
    // 字体样式
    {
        path: '/fontStyle',
        name: 'fontStyle',
        meta: {
            title: '字体样式',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/fontStyle.vue'], resolve),
    },
    // 仿写模板
    {
        path: '/imitateTemplate',
        name: 'imitateTemplate',
        meta: {
            title: '仿写模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/touch/imitateTemplate.vue'], resolve),
    },
    // 礼包套餐
    {
        path: '/packageItems',
        name: 'packageItems',
        meta: {
            title: '礼包套餐',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/packageItems.vue'], resolve),
    },
    // 套餐充值
    {
        path: '/packageOrder',
        name: 'packageOrder',
        meta: {
            title: '套餐充值',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/packageOrder.vue'], resolve),
    },
    // 首页Banner
    {
        path: '/banner',
        name: 'banner',
        meta: {
            title: '首页Banner',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/banner.vue'], resolve),
    },
    // API商品
    {
        path: '/APIGoods',
        name: 'APIGoods',
        meta: {
            title: 'API商品',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/APIGoods.vue'], resolve),
    },
    // API商品优惠卷
    {
        path: '/apiGoodsCoupon',
        name: 'apiGoodsCoupon',
        meta: {
            title: 'API商品优惠卷',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/apiGoodsCoupon.vue'], resolve),
    },
    // API劵码记录
    {
        path: '/apiCouponCode',
        name: 'apiCouponCode',
        meta: {
            title: 'API劵码记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/apiCouponCode.vue'], resolve),
    },
    // 渠道配置
    {
        path: '/channelConfig',
        name: 'channelConfig',
        meta: {
            title: '渠道配置',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/channelConfig.vue'], resolve),
    },
    // 碰一碰价格模板
    {
        path: '/touch_template',
        name: 'touch_template',
        meta: {
            title: '碰一碰价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/touch_template.vue'], resolve),
    },
    // 碰一碰价格模板
    {
        path: '/touch_template_add',
        name: 'touch_template_add',
        meta: {
            title: '碰一碰价格模板',
            keepAlive: false
        },
        component: resolve => require(['@/views/rules/touch_template_add.vue'], resolve),
    },
    // 即火商品
    {
        path: '/jh_goods',
        name: 'jh_goods',
        meta: {
            title: '即火商品',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/jh_goods.vue'], resolve),
    },
    // 即火商品
    {
        path: '/source_list',
        name: 'source_list',
        meta: {
            title: '素材管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/source_list.vue'], resolve),
    },
    // 京东拦截商品
    {
        path: '/InterceptJdGoods',
        name: 'InterceptJdGoods',
        meta: {
            title: '京东拦截商品',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/InterceptJdGoods.vue'], resolve),
    },
    // 京东拦截商品
    {
        path: '/channelInterceptVue',
        name: 'channelInterceptVue',
        meta: {
            title: '京东拦截商品',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/coms/channelInterceptVue.vue'], resolve),
    },
    // 京东城市价格
    {
        path: '/jdCityPrice',
        name: 'jdCityPrice',
        meta: {
            title: '京东城市价格',
            keepAlive: false
        },
        component: resolve => require(['@/views/channel/jdCityPrice.vue'], resolve),
    },
    // 即火京东价格
    {
        path: '/fxzb_price_tmpl',
        name: 'fxzb_price_tmpl',
        meta: {
            title: '即火京东价格',
            keepAlive: false
        },
        component: resolve => require(['@/views/jhtask/fxzb_price_tmpl.vue'], resolve),
    },
    // 领取记录
    {
        path: '/activityRecord',
        name: 'activityRecord',
        meta: {
            title: '领取记录',
            keepAlive: false
        },
        component: resolve => require(['@/views/local/activityRecord.vue'], resolve),
    },
    
    // 全部订单
    {
        path: '/jd_allOrder',
        name: 'jd_allOrder',
        meta: {
            title: '全部订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_allOrder.vue'], resolve),
    },
    // 待抢订单
    {
        path: '/jd_robingOrder',
        name: 'jd_robingOrder',
        meta: {
            title: '待抢订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_robingOrder.vue'], resolve),
    },
    // 无人接单
    {
        path: '/jd_norecevOrder',
        name: 'jd_norecevOrder',
        meta: {
            title: '无人接单',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_norecevOrder.vue'], resolve),
    },
    // 锁定订单
    {
        path: '/jd_lockingOrder',
        name: 'jd_lockingOrder',
        meta: {
            title: '锁定订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_lockingOrder.vue'], resolve),
    },
    // 待确认订单
    {
        path: '/jd_confirmOrder',
        name: 'jd_confirmOrder',
        meta: {
            title: '待确认订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_confirmOrder.vue'], resolve),
    },
    // 出票成功订单
    {
        path: '/jd_successOrder',
        name: 'jd_successOrder',
        meta: {
            title: '出票成功订单',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_successOrder.vue'], resolve),
    },
    // 报价设置
    {
        path: '/jd_quotationSetting',
        name: 'jd_quotationSetting',
        meta: {
            title: '报价设置',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_quotationSetting.vue'], resolve),
    },
    // 京东承包规则审核
    {
        path: '/jdContract',
        name: 'jdContract',
        meta: {
            title: '京东承包规则审核',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jdContract.vue'], resolve),
    },
    // 京东规则查询
    {
        path: '/jd_rule',
        name: 'jd_rule',
        meta: {
            title: '京东规则查询',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_rule.vue'], resolve),
    },
    // 接单设置
    {
        path: '/jd_receive_set',
        name: 'jd_receive_set',
        meta: {
            title: '接单设置',
            keepAlive: false
        },
        component: resolve => require(['@/views/jdOrder/jd_receive_set.vue'], resolve),
    },
    // 模块管理
    {
        path: '/jh_module',
        name: 'jh_module',
        meta: {
            title: '模块管理',
            keepAlive: false
        },
        component: resolve => require(['@/views/jh/jh_module.vue'], resolve),
    },
    ]
},
{
    path: '/login',
    name: 'Login',
    meta: {
        title: '登录',
        keepAlive: false
    },
    components: {
        blank: resolve => require(['@/views/login/Login.vue'], resolve),
    }
},
{
    path: '/*',
    name: 'NotFound',
    meta: {
        title: '404',
        keepAlive: true
    },
    components: {
        blank: resolve => require(['@/views/error/404.vue'], resolve),
    }
}
]

export default new Router({
    routes: RouteList
})